import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionForm_Mission_CollaborationTurn_Mutation = graphql(`
  mutation MissionForm_Mission_CollaborationTurn(
    $missionId: Id!
    $collaboration: MissionInput!
    $missionUpdate: MissionInput!
    $versionData: VersionDataInput
  ) {
    turnMissionIntoCollaboration(
      missionId: $missionId
      collaboration: $collaboration
      missionUpdate: $missionUpdate
      versionData: $versionData
    ) {
      _id
      compositeMissionId
    }
  }
`);

export type MissionForm_Mission_CollaborationTurn_Result = ResultOf<
  typeof MissionForm_Mission_CollaborationTurn_Mutation
>;

export const useTurnMissionIntoCollaborationMutation = () =>
  useGraphQLMutation(MissionForm_Mission_CollaborationTurn_Mutation);
